import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from '~/lib/react-router-dom';

import { Button } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import { fetchPaginatedRatePlans } from '../../actions/ratePlans';
import dateFormatter from '../../utils/dateFormatter';

import GridPagination from './Elements/GridPagination';

interface Props {
  source: string;
}

const PAGE_SIZE = 20;

export default function PaginatedRatePlanList({ source }: Props) {
  const dispatch = useDispatch();
  const { ratePlans, total, vendorNames, loading } = useSelector((state: any) => state.ratePlans);
  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(fetchPaginatedRatePlans(source, page + 1, PAGE_SIZE, 'created_at', 'desc'));
  }, [dispatch, source, page]);

  const editBtnFormatter = (vendorId: string, ratePlanId: string) => {
    return (
      <Button component={Link} to={`vendors/${vendorId}/rate-plans/${ratePlanId}`} variant="text">
        Edit
      </Button>
    );
  };

  const columns: Array<GridColDef> = [
    {
      field: 'name',
      headerName: 'Name',
      disableColumnMenu: true,
      minWidth: 125,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.value;
      },
      display: 'flex',
    },
    {
      field: 'created_at',
      headerName: 'Created at',
      disableColumnMenu: true,
      minWidth: 125,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return dateFormatter(params.value);
      },
      display: 'flex',
    },
    {
      field: 'id_salesforce_external',
      headerName: 'Vendor',
      disableColumnMenu: true,
      minWidth: 125,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return vendorNames[params.value] || params.value;
      },
      display: 'flex',
    },
    {
      field: 'edit',
      headerName: 'Edit',
      disableColumnMenu: true,
      sortable: false,
      minWidth: 70,
      flex: 0,
      renderCell: (params: GridRenderCellParams) => {
        return editBtnFormatter(params.row?.id_salesforce_external, params.row?.id);
      },
      display: 'flex',
    },
  ];

  return (
    <DataGrid
      className="T-rate-plan-table"
      loading={loading}
      rows={ratePlans}
      columns={columns}
      pageSizeOptions={[PAGE_SIZE]}
      paginationModel={{ pageSize: PAGE_SIZE, page }}
      onPaginationModelChange={({ page }) => setPage(page)}
      getRowId={(row) => row.id}
      getRowHeight={() => 'auto'}
      rowCount={total}
      paginationMode="server"
      slots={{
        pagination: GridPagination,
      }}
      autoHeight
      disableRowSelectionOnClick
      sx={{ mt: 2 }}
    />
  );
}
